module.exports = __webpack_public_path__ + "static/img/bc@2x.fa8dae8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/bc@2x.png
// module id = tQzL
// module chunks = 1